import { CapacitorHttp, HttpResponse } from '@capacitor/core';

import {getBaseDomain, isNative} from '@/utils/platform';
import { AuthService } from '@/services/AuthService';

export async function apiFetch(endpoint: string, options: any = {}) {
    const session = await AuthService.findSession();
    const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
    let url = `/api/${cleanEndpoint}`;

    if (isNative) {
        const backendBaseUrl = options.baseUrlOverride || await getBaseDomain();
        url = `${backendBaseUrl}${url}`;
    }

    const headers: Record<string, string> = { ...(options.headers || {}) };
    if (!headers['Content-Type']) {
        headers['Content-Type'] = 'application/json';
    }

    if (session?.token && (session.source !== 'cookie' || isNative)) {
        headers['Authorization'] = `Bearer ${session.token}`;
    }

    let response: any;
    if (isNative) {
        const nativeOptions = {
            url,
            method: options.method || 'GET',
            headers,
            data: options.body ? (typeof options.body === 'string' ? JSON.parse(options.body) : options.body) : undefined,
        };

        const nativeRes = await CapacitorHttp.request(nativeOptions);

        response = {
            ok: nativeRes.status >= 200 && nativeRes.status < 300,
            status: nativeRes.status,
            json: async () => nativeRes.data,
            text: async () => typeof nativeRes.data === 'string' ? nativeRes.data : JSON.stringify(nativeRes.data),
        };
    } else {
        response = await fetch(url, {
            ...options,
            headers,
            credentials: 'include'
        });
    }

    if (response.status === 401) {
        await AuthService.logout();
        window.location.href = '/login';
        throw new Error("Unauthorized");
    }

    return response;
}

export const apiFetchExternal = async (fullUrl: string, payload: any) => {
    if (isNative) {
        const response = await CapacitorHttp.post({
            url: fullUrl,
            headers: { "Content-Type": "application/json" },
            data: { payload }
        });

        // Normalize to match Fetch API
        return {
            ok: response.status >= 200 && response.status < 300,
            status: response.status,
            json: async () => response.data,
            text: async () => typeof response.data === 'string' ? response.data : JSON.stringify(response.data),
        };
    }

    return fetch(fullUrl, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ payload })
    });
}